import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import {ProjectColors} from '../../Enums/Core/projectColors'
import {Spinner} from 'react-bootstrap'
import React from 'react'

export default function DonutChart(props) {
    const data = props.data;
    let total = 0;
    props.data.forEach(flowType => {
        total += flowType[1];
    });

    const getSeriesByIndex = (index) => {
        switch (index) {
            case 0: {
                return 'Low Flow'
                break;
            }
            case 1: {
                return 'Moderate Flow'
                break;
            }
            case 2: {
                return 'High Flow'
                break;
            }
        }
    }

    const options = {
        chart: {
            type: 'pie', height: props.height || 200
        }, title: {
            verticalAlign: 'middle', floating: true, text: `${total.toLocaleString()}<br>Total`
        }, plotOptions: {
            pie: {
                shadow: false,
                center: ['50%', '50%'],
                colors: [ProjectColors.Orange, ProjectColors.Red, ProjectColors.DarkRed]
            }
        }, series: [{
            name: 'Amount', data: data, size: props.size, innerSize: '75%', dataLabels: {
                formatter: function () {
                    return null;
                }
            }
        }], credits: {
            enabled: false
        },
        tooltip: {
            formatter: function () {
                let dataToShow = [];
                let i = 0
                this.series.options.data.forEach(arr => {
                    dataToShow.push(getSeriesByIndex(i) + ': ' + arr[1].toLocaleString() + '<br>')
                    i++;
                })
                dataToShow.push('Total: ' + this.total?.toLocaleString())

                return dataToShow
            }

        }
    }

    return (<>
            {props.data.length === 0 && <Spinner animation="border" variant="primary"/>}
            {props.data.length > 0 && <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />}
        </>
    )
}
